/* CBRE SLIDER */

export function initCbreSlider() {
    $.fn.cbreSlider = function (settings) {
        var defaults = {
            slider: $(this),

            base: {
                holder: ".holder",

                sliderContainer: ".slider",

                slideWrapper: ".slide-wrapper",

                numSlides: 0, //Total elements, (autocalculate)

                numDisplaySlides: 1, //Num of slides to show at same time

                numDisplaySlidesMobile: 1, //Num of slides to show at same time in mobile

                numSlidePages: 0, //Num pages of slides (autocalculate)

                numSlidePagesLast: 0, //Num pages of last slides (autocalculate)

                sliderFooterClass: ".slider-footer",
            },

            spacing: 0,

            navigation: {
                active: true,

                container: ".slider-navigation",

                nextSlideClassBtn: ".slider-nav-next",

                prevSlideClassBtn: ".slider-nav-prev",

                nextSlideBtn: false,

                prevSlideBtn: false,

                mobileBreakPoint: 1024,

                hideNavButtonMobile: true,

                onTitle: false,

                positionTop: "50%",
            },

            dots: {
                container: ".slider-navigation-dots",

                listBoxContainer: "ul",

                listBoxElement: "li",

                dotElement: "a",
            },

            theme: "default",

            slideWidth: "",

            widthSingleElement: 0,

            desktop: true,

            mobileOnly: false,

            touchmove: true,

            touchstartx: undefined,

            touchmovex: undefined,

            movexLimit: 0,

            movex: undefined,

            index: 0,

            longTouch: undefined,

            onInit: function () {},

            onChange: function () {},

            onReachLastElement: function () {},
        };

        var options = $.extend(true, defaults, settings);

        var slider = {
            init: function () {
                options.slider.addClass("theme-" + options.theme);

                // options.slideWidth = options.slider.width();

                options.base.holder = options.slider.find(options.base.holder);

                options.base.holder.css("gap", options.spacing + "px");

                options.base.numSlides = options.slider.find(
                    options.base.slideWrapper
                ).length;

                // options.base.holder.css('width', options.slideWidth*(options.base.numSlides));

                // options.base.numSlidePages = Math.ceil(options.base.numSlides/options.base.numDisplaySlides);

                //Calcular num slides segun los hijos y NumdisplaySlides, Math.ceil()

                //options.base.numSlides = options.slider.find(options.base.slideWrapper).length;

                // this.setHolderWidth();

                this.reCalculate();

                this.buildNavigation(false);

                // console.log(options.base.numSlides);

                $(window).resize(function () {
                    slider.reSize();
                });

                // this.reCalculate();

                this.bindUIEvents(false);

                this.toggleTouchMove();

                //Hook onInit

                options.onInit(options);
            },

            animateSlider: function () {
                // console.log(options.base.numSlides);

                // console.log("sliderWidth", typeof options.spacing);

                options.base.holder
                    .addClass("animate")
                    .css(
                        "transform",
                        "translate3d(-" +
                            options.index *
                                (options.slideWidth + options.spacing) +
                            "px,0,0)"
                    );

                // if($(window).width() <= options.navigation.mobileBreakPoint){

                //   options.base.holder.addClass('animate').css('transform', 'translate3d(-' + options.index*(options.slideWidth+(options.spacing*(options.base.numSlides-1))-options.spacing) + 'px,0,0)');

                // }else{

                //   options.base.holder.addClass('animate').css('transform', 'none');

                // }
            },

            setHolderWidth: function () {
                // console.log("singleElement", options.widthSingleElement);

                // console.log("spacing", options.spacing * (options.base.numSlides - 1));

                // console.log("tot", options.widthSingleElement * (options.base.numSlides) + (options.spacing * (options.base.numSlides - 1)));

                // console.error('Sigle Width --> ' + options.widthSingleElement);

                // console.error(options.widthSingleElement * (options.base.numSlides) + (options.spacing * (options.base.numSlides - 1)))

                options.base.holder.css(
                    "width",
                    options.widthSingleElement * options.base.numSlides +
                        options.spacing * (options.base.numSlides - 1)
                );
            },

            toggleTouchMove: function () {
                if ($(window).width() <= options.navigation.mobileBreakPoint) {
                    options.touchmove = true;
                } else {
                    options.touchmove = false;
                }
            },

            reSize: function () {
                this.toggleTouchMove();

                this.reCalculate();

                if (
                    options.base.numSlidePagesLast != options.base.numSlidePages
                ) {
                    this.buildNavigation(true);
                }

                this.bindUIEvents(true);

                this.setHolderWidth();

                // options.base.holder.css('width', options.slideWidth*(options.base.numSlides));

                this.animateSlider();

                if (
                    options.base.numSlidePagesLast != options.base.numSlidePages
                ) {
                    this.toIndex(0);
                }

                // console.log("numSlides", options.base.numSlides);

                // console.log("numSlidePages", options.base.numSlidePages);

                // this.toIndex(0); //Reset index

                // options.base.holder.addClass('animate').css('transform', 'translate3d(-' + options.index*options.slideWidth + 'px,0,0)');
            },

            reCalculate: function () {
                var numDisplaySlides = options.base.numDisplaySlides;

                if ($(window).width() <= options.navigation.mobileBreakPoint) {
                    numDisplaySlides = options.base.numDisplaySlidesMobile;
                }

                options.base.numSlidePagesLast = options.base.numSlidePages;

                options.base.numSlidePages = Math.ceil(
                    options.base.numSlides / numDisplaySlides
                );

                //Ajustar tamaño de los slides

                var sliderFullWidth = options.slider
                    .find(options.base.sliderContainer)
                    .width();

                options.widthSingleElement =
                    sliderFullWidth / numDisplaySlides -
                    (options.spacing * (numDisplaySlides - 1)) /
                        numDisplaySlides;

                options.slider
                    .find(options.base.slideWrapper)
                    .width(options.widthSingleElement);

                // sliderFullWidth/numDisplaySlides - (sliderFullWidth/) 32*2/3

                //Mobile

                if ($(window).width() <= options.navigation.mobileBreakPoint) {
                    //Comprobar si es versión mobile y esconder la navegación si se debe

                    if (options.navigation.hideNavButtonMobile)
                        options.slider
                            .find(options.navigation.container)
                            .hide();

                    // Comprobar si se deben mostrar los dots

                    if (options.mobileOnly)
                        options.slider.find(options.dots.container).show();
                }

                //Desktop
                else {
                    //Comprobar si es versión desktop y mostrar la navegación si se debe

                    if (options.navigation.hideNavButtonMobile)
                        options.slider
                            .find(options.navigation.container)
                            .show();

                    // Comprobar si se deben ocultar los dots

                    if (options.mobileOnly)
                        options.slider.find(options.dots.container).hide();
                }

                options.slideWidth = options.slider.width();

                if (
                    $(window).width() <= options.navigation.mobileBreakPoint ||
                    options.desktop
                ) {
                    this.setHolderWidth();

                    // options.base.holder.css('width', options.slideWidth*(options.base.numSlides)+(options.spacing*(options.base.numSlides-1)));
                }

                //Si no se ha creado el slider aun

                if (options.slideWidth <= 0) {
                    myInterval = setInterval(function () {
                        // if(slider.slideWidth <= 0){

                        options.slideWidth = options.slider.width();

                        if (options.slideWidth > 0) {
                            options.base.holder.css(
                                "width",
                                options.slideWidth * options.base.numSlides
                            );

                            options.moveXLimit =
                                options.slideWidth *
                                (options.base.numSlides - 1);

                            clearInterval(myInterval);
                        }
                    }, 100);
                }

                var newLimit =
                    options.slideWidth * (options.base.numSlides - 1);

                if (newLimit != 0) {
                    options.moveXLimit =
                        options.slideWidth * (options.base.numSlides - 1);
                }

                if (options.base.numSlidePages <= 1) {
                    options.slider.find(options.navigation.container).hide();

                    options.slider.find(options.dots.container).hide();
                } else {
                    options.slider.find(options.navigation.container).show();

                    options.slider.find(options.dots.container).show();
                }
            },

            buildNavigation: function (reBuildDots) {
                /* DOTS */

                var navDots =
                    "<" +
                    options.dots.listBoxContainer +
                    " class='col-gap-xs inline items-center justify-center unstyled'>";

                for (var i = 0; i < options.base.numSlidePages; i++) {
                    navDots +=
                        "<" +
                        options.dots.listBoxElement +
                        " " +
                        (i == 0 ? "class='active'" : "") +
                        "><" +
                        options.dots.dotElement +
                        " href='#' data-index='" +
                        i +
                        "'></" +
                        options.dots.dotElement +
                        "></" +
                        options.dots.listBoxElement +
                        ">";
                }

                navDots += "</" + options.dots.listBoxContainer + ">";

                options.slider.find(options.dots.container).html(navDots);

                var buttonsPosition = !options.navigation.onTitle
                    ? 'style="top:' + options.navigation.positionTop + '"'
                    : "";

                /* Nav Buttons next/prev */

                if (options.navigation.active && !reBuildDots) {
                    var nextNavBtn =
                        '<button class="slider-nav-btn ' +
                        (options.navigation.onTitle ? "title-btn " : "") +
                        options.navigation.nextSlideClassBtn.replace(
                            /^.|#/,
                            ""
                        ) +
                        '" ' +
                        buttonsPosition +
                        '><img src="/images/icons/right.svg" title="Siguiente" alt="Siguiente" loading="lazy"></button>';

                    var prevNavBtn =
                        '<button class="slider-nav-btn ' +
                        (options.navigation.onTitle ? "title-btn " : "") +
                        options.navigation.prevSlideClassBtn.replace(
                            /^.|#/,
                            ""
                        ) +
                        '" ' +
                        buttonsPosition +
                        '><img src="/images/icons/right.svg" title="Siguiente" alt="Siguiente" loading="lazy"></button>';

                    options.slider
                        .find(options.navigation.container)
                        .html(nextNavBtn + prevNavBtn);
                }
            },

            bindUIEvents: function (reBuildDots) {
                var functions = this;

                /* Navigation */

                if (!reBuildDots) {
                    if (options.navigation.active) {
                        (options.navigation.nextSlideBtn = options.slider.find(
                            options.navigation.nextSlideClassBtn
                        )),
                            (options.navigation.prevSlideBtn =
                                options.slider.find(
                                    options.navigation.prevSlideClassBtn
                                )),
                            options.navigation.prevSlideBtn.addClass(
                                "disabled"
                            );

                        /*  Next/Prev buttons */

                        options.navigation.nextSlideBtn.on(
                            "click",
                            function (event) {
                                slider.toIndex(options.index + 1);
                            }
                        );

                        options.navigation.prevSlideBtn.on(
                            "click",
                            function (event) {
                                slider.toIndex(options.index - 1);
                            }
                        );
                    }

                    options.base.holder.on("touchstart", function (event) {
                        slider.start(event);
                    });

                    options.base.holder.on("touchmove", function (event) {
                        slider.move(event);
                    });

                    options.base.holder.on("touchend", function (event) {
                        slider.end(event);
                    });
                }

                /* Event Dots */

                options.slider
                    .find(options.dots.container)
                    .find(
                        options.dots.listBoxContainer +
                            " " +
                            options.dots.listBoxElement +
                            " " +
                            options.dots.dotElement
                    )
                    .on("click", function (event) {
                        if (typeof $(this).data("index") !== "undefined") {
                            slider.toIndex($(this).data("index"));
                        }

                        event.preventDefault();
                    });
            },

            start: function (event) {
                // this.reCalculate();

                if (!options.touchmove) {
                    return false;
                }

                // Test for flick.

                options.longTouch = false;

                setTimeout(function () {
                    slider.longTouch = true;
                }, 250);

                // Get the original touch position.

                options.touchstartx = event.originalEvent.touches[0].pageX;

                // The movement gets all janky if there's a transition on the elements.

                options.base.holder.removeClass("animate");
            },

            move: function (event) {
                if (!options.touchmove) {
                    return false;
                }

                // this.reCalculate();

                // Continuously return touch position.

                options.touchmovex = event.originalEvent.touches[0].pageX;

                // Calculate distance to translate holder.

                options.movex =
                    options.index * options.slideWidth +
                    (options.touchstartx - options.touchmovex);

                // Defines the speed the images should move at.

                var panx = 100 - options.movex / (options.base.numSlides * 2);

                if (options.movex < options.moveXLimit) {
                    // Makes the holder stop moving when there is no more content.

                    options.base.holder.css(
                        "transform",
                        "translate3d(-" + options.movex + "px,0,0)"
                    );
                }

                /*if (panx < 100) { // Corrects an edge-case problem where the background image moves without the container moving.
  
                    this.el.imgSlide.css('transform','translate3d(-' + panx + 'px,0,0)');
  
                  }*/
            },

            end: function (event) {
                if (!options.touchmove) {
                    return false;
                }

                // Calculate the distance swiped.

                var absMove = Math.abs(
                    options.index * options.slideWidth - options.movex
                );

                // Calculate the index. All other calculations are based on the index.

                if (
                    absMove > options.slideWidth / 3 &&
                    options.longTouch === false
                ) {
                    if (
                        options.movex > options.index * options.slideWidth &&
                        options.index < options.base.numSlides - 1
                    ) {
                        this.toIndex(options.index + 1);
                    } else if (
                        options.movex < options.index * options.slideWidth &&
                        options.index > 0
                    ) {
                        this.toIndex(options.index - 1);
                    } else {
                        this.toIndex(options.index);
                    }
                } else {
                    this.toIndex(options.index);
                }
            },

            toIndex: function (slideIndex) {
                options.onChange(options, slideIndex);

                if (slideIndex >= 0 && slideIndex < options.base.numSlides) {
                    options.index = slideIndex;
                }

                //Esconder boton slider anterior si no hay mas slides antes

                if (options.navigation.active) {
                    if (slideIndex <= 0) {
                        options.navigation.prevSlideBtn.addClass("disabled");
                    } else {
                        options.navigation.prevSlideBtn.removeClass("disabled");
                    }
                }

                //Esconder boton slider siguiente si no hay mas slides después

                if (slideIndex >= options.base.numSlidePages - 1) {
                    if (options.navigation.active)
                        options.navigation.nextSlideBtn.addClass("disabled");

                    // options.slider.find(options.sliderFooterClass).find(".link-tasacion").addClass("primary-btn").removeClass("text-underline");

                    //link-tasacion
                } else {
                    // options.slider.find(options.sliderFooterClass).find(".link-tasacion").removeClass("primary-btn").addClass("text-underline");

                    if (options.navigation.active)
                        options.navigation.nextSlideBtn.removeClass("disabled");
                }

                options.slider
                    .find(options.dots.container)
                    .find(
                        options.dots.listBoxContainer +
                            " " +
                            options.dots.listBoxElement
                    )
                    .removeClass("active");

                options.slider
                    .find(options.dots.container)
                    .find(
                        options.dots.listBoxContainer +
                            " " +
                            options.dots.listBoxElement +
                            ":nth-child(" +
                            (options.index + 1) +
                            ")"
                    )
                    .addClass("active");

                // console.log(options.index*(options.slideWidth+(32*options.base.numSlides-1)));

                this.animateSlider();

                // options.base.holder.addClass('animate').css('transform', 'translate3d(-' + options.index*(options.slideWidth+(options.spacing*(options.base.numSlides-1))-options.spacing) + 'px,0,0)');
            },
        };

        slider.init();
    };

    // $('#news-container').cbreSlider({

    //     theme: 'light',

    //     navigation: {active: false, mobileBreakPoint: 1024},

    // });
}
